import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SiDotnet, SiExpress, SiNodedotjs } from 'react-icons/si';

const BackEnd = () => {
  return (
    <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiNodedotjs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDotnet />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiExpress />
      </Col>
    </Row>
  );
};

export default BackEnd;
